/**
 * @description
 * @author librajt
 */

import './pageSliderNavArrow.scss';

import React from 'react';
import { classSet } from '@umu/umu-dom';
import { ArrowDirection } from '@umu/umu-types';

// export enum ArrowDirection {
//     UP = 'up',
//     RIGHT = 'right',
//     DOWN = 'down',
//     LEFT = 'left',
// }

interface IProps {
    direction?: ArrowDirection;
}

export default function PageSliderNavArrow(props: IProps = {}) {
    const className = classSet('page-slider-nav-arrow', props.direction || ArrowDirection.UP);
    return (
        <div className={className}>
            <div className="arrow-icon">
                <span className="before"></span>
                <span className="after"></span>
            </div>
        </div>
    );
}
